import React from "react";
import ShadeBackgound from "./ShadeBackgound";
import Card from "./Card";
import ErrorIcon from "../../assets/responsiveIcons/ErrorIcon";

function ErrorDisplay({ message, onClose, onSwitchNetwork }) {
  return (
    <>
      {/* Background blur effect */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10, // Lower z-index than the Card
          backdropFilter: 'blur(2px)', // Apply blur effect to the background
          transition: 'backdrop-filter 0.3s ease', // Smooth transition for the blur effect
        }}
      ></div>
      
      <ShadeBackgound onClick={onClose} opacity={0.3}></ShadeBackgound>
      
      {/* Popup Card */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 20, // Higher z-index for the Card
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Card className="px-8 py-4 flex flex-col items-center gap-5 w-100"> {/* Adjusted width and height */}
          <div className="mt-2">
            <ErrorIcon />
          </div>
          <div className="flex mt-1 flex-col items-center">
            <p className="text-2xl font-semibold">Unsupported Network.</p>
            <p className="text-sm w-60 break-words whitespace-normal text-center">
              {/* {message} */}
              Please switch to a supported network in MetaMask.
            </p>
          </div>
          {/* <button
            onClick={onClose}
            className="px-[0.68rem] py-2 text-sm bg-sunny-secondary dark:bg-dark-secondary rounded-sm"
          >
            Close
          </button> */}
          {/* Custom Button for Switching Network */}
          
         <button
            onClick={onSwitchNetwork}
            className="mt-2 px-[0.68rem] py-2 text-sm bg-blue-500 text-white rounded-md" // Changed to rounded-md
          >
            Switch Network
          </button>

        </Card>
      </div>
    </>
  );
}

export default ErrorDisplay;
